import { action, observable, runInAction } from 'mobx';

import {
    AirCompaniesInTourTipParams,
    NotificationEvents,
    TourActualizationResultEvent,
    TourDetailsCopyResultEvent
} from '../../models/notification';
import { DirectionEndPointData } from '../../models/flights';
import { TourPriceStatus } from '../../models/actualization';


export class NotificationStore {

    @observable
    displayedEvent = NotificationEvents.Nothing;

    @observable
    selectedFlightEndPointParams: Partial<DirectionEndPointData> = {};

    @observable
    airCompaniesInFlightsTipParams: AirCompaniesInTourTipParams = {
        airCompaniesNames: []
    };

    @observable
    selectedTourPriceStatus = TourPriceStatus.Default;


    private displayTimer: number | null = null;

    private DISPLAY_TIMEOUT: number = 10000;


    hide(): void {
        this.setEvent(NotificationEvents.Nothing);
        if (this.displayTimer) {
            clearTimeout(this.displayTimer);
        }
    }

    showVerifiedTour(): void {
        if (this.displayTimer) {
            clearTimeout(this.displayTimer);
        }
        this.setEvent(NotificationEvents.TourHadVerified);
        this.setTimer(
            window.setTimeout(() => this.hide(), this.DISPLAY_TIMEOUT)
        );
    }

    showTourNotVerified(): void {
        if (this.displayTimer) {
            clearTimeout(this.displayTimer);
        }
        this.setEvent(NotificationEvents.TourNotVerified);
        this.setTimer(
            window.setTimeout(() => this.hide(), this.DISPLAY_TIMEOUT)
        );
    }

    showVerifiedTourSold(): void {
        if (this.displayTimer) {
            clearTimeout(this.displayTimer);
        }
        this.setEvent(NotificationEvents.VerifiedTourSold);
        this.setTimer(
            window.setTimeout(() => this.hide(), this.DISPLAY_TIMEOUT)
        );
    }

    showFlightEndPoint(params: Partial<DirectionEndPointData>): void {
        if (this.displayTimer) {
            clearTimeout(this.displayTimer);
        }

        runInAction(() => {
            this.selectedFlightEndPointParams = params;
        });

        this.setEvent(NotificationEvents.ClickOnFlightEndPoint);
        this.setTimer(
            window.setTimeout(() => this.hide(), this.DISPLAY_TIMEOUT)
        );
    }

    showWrongFlightDestination(): void {
        if (this.displayTimer) {
            clearTimeout(this.displayTimer);
        }
        this.setEvent(NotificationEvents.ClickOnWrongDestinationTip);
        this.setTimer(
            window.setTimeout(() => this.hide(), this.DISPLAY_TIMEOUT)
        );
    }

    showFlightsAirCompanies(params: AirCompaniesInTourTipParams): void {
        if (this.displayTimer) {
            clearTimeout(this.displayTimer);
        }

        runInAction(() => {
           this.airCompaniesInFlightsTipParams = params;
        });

        this.setEvent(NotificationEvents.ClickOnAirCompanyTip);
        this.setTimer(
            window.setTimeout(() => this.hide(), this.DISPLAY_TIMEOUT)
        );
    }

    showTourPriceStatusTip(priceStatus: TourPriceStatus): void {
        if (this.displayTimer) {
            clearTimeout(this.displayTimer);
        }

        runInAction(() => {
            this.selectedTourPriceStatus = priceStatus;
        });

        this.setEvent(NotificationEvents.ClickOnTourPriceStatusTip);
        this.setTimer(
            window.setTimeout(() => this.hide(), this.DISPLAY_TIMEOUT)
        );
    }

    showTourDetailsCopyResult(event: TourDetailsCopyResultEvent): void {
        if (this.displayTimer) {
            clearTimeout(this.displayTimer);
        }

        this.setEvent(event);
        this.setTimer(
            window.setTimeout(() => this.hide(), this.DISPLAY_TIMEOUT)
        );
    }

    showTourActualizationTooltip(event: TourActualizationResultEvent): void {
        if (this.displayTimer) {
            clearTimeout(this.displayTimer);
        }

        this.setEvent(event);
        this.setTimer(
            window.setTimeout(() => this.hide(), this.DISPLAY_TIMEOUT)
        );
    }

    showTotalHotelReviewRatingTooltip(): void {
        if (this.displayTimer) {
            clearTimeout(this.displayTimer);
        }

        this.setEvent(NotificationEvents.ClickOnTotalReviewsRating);
        this.setTimer(
            window.setTimeout(() => this.hide(), this.DISPLAY_TIMEOUT)
        );
    }


    showAddTourToBasketSuccess(): void {
        if (this.displayTimer) {
            clearTimeout(this.displayTimer);
        }

        this.setEvent(NotificationEvents.AddTourToBasketSuccess);
        this.setTimer(
            window.setTimeout(() => this.hide(), this.DISPLAY_TIMEOUT)
        );
    }

    @action
    private setEvent(event: NotificationEvents): void {
        this.displayedEvent = event;
    }

    private setTimer(val: number | null) {
        this.displayTimer = val;
    }

}
